import { ChangeDetectionStrategy, Component, effect } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MdsTextFieldComponent } from '@medpacesoftwaredevelopment/designsystem';
import { StudyExpenseTrackingDataRow } from '@models/studyExpenseTrackingDataRow';
import { BaseCellEditorComponent } from '../base-cell-editor/base-cell-editor.component';

@Component({
    selector: 'app-custom-cell-editor-input',
    imports: [MdsTextFieldComponent],
    templateUrl: './custom-cell-editor-input.component.html',
    styleUrl: './custom-cell-editor-input.component.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCellEditorInputComponent<TValue = unknown, TContext = unknown> extends BaseCellEditorComponent<
    StudyExpenseTrackingDataRow,
    TValue,
    TContext,
    {
        inputType: 'number' | 'text' | 'email' | 'password' | 'decimal' | 'tel' | 'integer';
        convertValue: (valueAsString: string) => TValue;
    }
> {
    formControl = new FormControl<TValue | null>(null);
    setInitialValue = effect(() => {
        const baseParams = this.baseParams();
        if (!baseParams) return;

        if (!baseParams || baseParams.value === undefined) return; // this.formControl.setValue(undefined); will cause MDS errors ;__;
        this.formControl.setValue(baseParams.value);
    });
    getValue(): TValue {
        if (this.customParams().convertValue) return this.formControl.value;
        return this.formControl.value;
    }
    save() {
        this.baseParams().api.stopEditing(false);
    }
}
